import { IconProps } from '@repo/core/global-data/dataInterface.data';


const SuccessIcon = ({ width = '48', height = '48', className = '' }: IconProps) => {
    return (
        <span className={className}>
            <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* Background Circle */}
                <path
                    opacity="0.4"
                    d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
                    fill="currentColor"
                />
                {/* Checkmark Path */}
                <path
                    d="M21.1599 31.1602C20.7599 31.1602 20.3799 31.0002 20.0999 30.7202L14.4399 25.0602C13.8599 24.4802 13.8599 23.5202 14.4399 22.9402C15.0199 22.3602 15.9799 22.3602 16.5599 22.9402L21.1599 27.5402L31.4399 17.2602C32.0199 16.6802 32.9799 16.6802 33.5599 17.2602C34.1399 17.8402 34.1399 18.8002 33.5599 19.3802L22.2199 30.7202C21.9399 31.0002 21.5599 31.1602 21.1599 31.1602Z"
                    fill="currentColor"
                />
            </svg>
        </span>
    );
};

export default SuccessIcon;
